
define("json!gigaset_contentbridge/handles/gigaset_contentbridge.json", function(){ return {
	"gigaset_contentbridge_cms_page": [
		"./components/faq",
		"./components/customer-service",
		"./components/contact-form",
		"./components/news",
		"./components/manuals",
        "./components/slider",
		"./components/gallery"
	]
};});

